/* eslint-disable react/no-unused-prop-types */
import { FC } from 'react'
import { Typography, Row, Col } from 'antd'
import styled from 'styled-components'
import { getQuestions, ValidQuestionKeys } from '../../hooks/useGerateQuestions'
import { mapQuestionNames } from '../../const'
import { CustomFormInstance } from '../../types'
// import { FormValues } from '../../utils/forms/methods/types'

const { Title, Text } = Typography

type Props = {
    formRef: CustomFormInstance
    onItemClick: (name: ValidQuestionKeys) => void
    markedQuestions: ValidQuestionKeys[]
    contentBasedMarkedQuestions: ValidQuestionKeys[]
    category: keyof getQuestions
}

const RequestForHelp: FC<Props> = ({
    // formRef,
    onItemClick,
    markedQuestions,
    contentBasedMarkedQuestions,
    category,
}) => {
    // const titleKey = 'titleComponent'
    // const data = formRef.getFieldValue<FormValues['titleComponent']>([titleKey])

    const mergedQuestionsList = [
        ...new Set([...markedQuestions, ...contentBasedMarkedQuestions]),
    ]

    const getName = (item: ValidQuestionKeys): string => {
        if (
            item === 'backgroundInvention' ||
            item === 'commonName' ||
            item === 'summaryOfSelectedEmbodimentsOfTheInvention' ||
            item === 'importantWeights' ||
            item === 'importantComponentsConnections'
        ) {
            return JSON.parse(mapQuestionNames[item])[category]
        }
        return `${mapQuestionNames[item]}`
    }

    return (
        <StyledContainer>
            <Title level={4}>Marked questions</Title>
            <Row>
                {mergedQuestionsList.map((item, index) => (
                    <Col span={24}>
                        <Text>{index + 1}.</Text>
                        <StyledText underline onClick={() => onItemClick(item)}>
                            {getName(item)}
                        </StyledText>
                    </Col>
                ))}
            </Row>
        </StyledContainer>
    )
}

export default RequestForHelp

const StyledContainer = styled.div`
    min-height: 300px;
`
const StyledText = styled(Text)`
    cursor: pointer;
    margin-left: 10px;
`
